import React from 'react';
// Constants
import { CompanyName, KeywordsPages, MainTitle } from '../../utils/Constants';
// Data
import {
  galleryPageAdditionalMeta,
  galleryPageStructuredData,
} from '../../utils/data/MetaData';
// Components
import Navbar from '../../components/nav/Navbar';
import { HelmetItem } from '../../components/utils/HelmetItem';
import GalleryPageMainContainer from '../../components/gallery/GalleryPageMainContainer';

function GalleryPage() {
  return (
    <>
      {/* Tab Data */}
      <HelmetItem
        PageName='Gallery'
        desc={`Enter the realm of ${CompanyName}, where dominance, seduction, and surrender intertwine. Discover My mastery, desires, and the unforgettable experiences that await you.`}
        keywords={KeywordsPages}
        additionalMeta={galleryPageAdditionalMeta}
        structuredData={galleryPageStructuredData}
      />

      {/* Page */}
      <div className='grid relative min-h-screen font-poppins bg-colour2 dark:bg-colour2 text-colour1 dark:text-colour1'>
        {/* Main */}
        <div className='grid min-h-screen'>
          {/* Navigation */}
          <Navbar />
          <header className='pt-24'>
            <h1 className='text-center font-titleFont text-5xl lg:text-7xl text-colour7 tracking-widest'>
              Personal Gallery
            </h1>
            <div className='mx-auto mt-2 grid justify-center px-4 text-center'>
              <h2>{MainTitle}</h2>
            </div>
          </header>

          {/* Main page content */}
          <GalleryPageMainContainer />
        </div>
      </div>
    </>
  );
}

export default GalleryPage;
